import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-curriculum-success',
  templateUrl: './curriculum-success.component.html',
  styleUrls: ['./curriculum-success.component.scss']
})
export class CurriculumSuccessComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() contactSupport = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();
}